export default __webpack_public_path__ + "static/media/notFound.173829a0.svg";